import { get, isNumber } from 'lodash';

export const CompleterNotification = {
  bindings: {
    weekNumber: '<',
    heading: '<',
    count: '<',
    total: '<',
    visible: '<',
  },

  template: `
    <div class="completer-notification"
      ng-class="{ appear: $ctrl.visible }">
      <progress-badge
        number="$ctrl.weekNumber"
        count="$ctrl.currentCount"
        total="$ctrl.total"
        size="lg">
      </progress-badge>
      <h3 class="mt-3 mb-1">
        {{ $ctrl.currentHeading }} Completed
      </h3>
      <p class="mb-0">
        Great, keep it up!
      </p>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        this.currentHeading = null;
        this.currentCount = this.count || 0;
      },

      $onChanges(changes) {
        const heading = get(changes, 'heading.currentValue');
        const headingPrev = get(changes, 'heading.previousValue');

        if (heading && heading !== headingPrev) {
          this.visible = true;
          this.currentHeading = heading;

          $timeout(() => this.animate(), 200);
          $timeout(() => this.hide(), 2000);
        }
      },

      hide() {
        this.visible = false;
        $timeout(() => (this.currentHeading = null), 500);
      },

      animate() {
        this.currentCount = this.count;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Completer/CompleterNotification.js